var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpFromBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.83333L10 2.5M10 2.5L6.66667 5.83333M10 2.5V12.5M17.5 9.16667V14.8327C17.5 15.7661 17.5 16.2328 17.3183 16.5893C17.1586 16.9029 16.9036 17.1579 16.59 17.3177C16.2335 17.4993 15.7668 17.4993 14.8333 17.4993H5.16667C4.23325 17.4993 3.76654 17.4993 3.41002 17.3177C3.09641 17.1579 2.84144 16.9029 2.68166 16.5893C2.5 16.2328 2.5 15.7661 2.5 14.8327V9.16667",
    stroke: "#4B4B4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFromBracket);
export default __webpack_public_path__ + "static/media/arrow-up-from-bracket.16f4f175985c82d52c17a92c6e467af9.svg";
export { ForwardRef as ReactComponent };